// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"181":"c7aec6be","249":"94ecbcfd","531":"84e1f72c","596":"39241971","671":"7474efea"}[chunkId] + ".css";
};